__turbopack_context__.v({
  "authCard": "auth-module-scss-module__8shKOW__authCard",
  "authPage": "auth-module-scss-module__8shKOW__authPage",
  "bgPulse": "auth-module-scss-module__8shKOW__bgPulse",
  "button": "auth-module-scss-module__8shKOW__button",
  "error": "auth-module-scss-module__8shKOW__error",
  "fadeIn": "auth-module-scss-module__8shKOW__fadeIn",
  "form": "auth-module-scss-module__8shKOW__form",
  "header": "auth-module-scss-module__8shKOW__header",
  "input": "auth-module-scss-module__8shKOW__input",
  "inputGroup": "auth-module-scss-module__8shKOW__inputGroup",
  "loading": "auth-module-scss-module__8shKOW__loading",
  "logo": "auth-module-scss-module__8shKOW__logo",
  "logoFloat": "auth-module-scss-module__8shKOW__logoFloat",
  "shake": "auth-module-scss-module__8shKOW__shake",
  "slideInRight": "auth-module-scss-module__8shKOW__slideInRight",
  "slideUp": "auth-module-scss-module__8shKOW__slideUp",
  "spin": "auth-module-scss-module__8shKOW__spin",
});
